export { default } from "./MTFooter";
